// Reset all user cart from a specific time stamp
export const checkForCustomerCartReset = (pageContext) => {
  if (typeof window !== 'undefined' && pageContext.shouldResetCustomersCarts) {
    const key = `checkoutId_${process.env.GATSBY_SHOPIFY_SHOP_NAME}_timestamp`;

    const removeCheckoutFromLocalStorage = () => {
      window.localStorage.removeItem(
        `checkoutId_${process.env.GATSBY_SHOPIFY_SHOP_NAME}`
      );
    };

    // check user has a cart key in locale storage
    if (!window.localStorage[key]) {
      removeCheckoutFromLocalStorage();
    } else {
      const checkoutTimeStamp = parseInt(window.localStorage[key]);

      if (
        checkoutTimeStamp &&
        checkoutTimeStamp < pageContext.cartMinResetTimestamp
      ) {
        removeCheckoutFromLocalStorage();
      }
    }
  }
};
